// @core/api/endpoints/product/create_product_dependency.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateProductDependencyRequest,
  ProductDependencyResponse,
} from '../../../types/product';

const BASE_PATH = '/product';

/**
 * Create product dependency
 * Declares that this product depends on another product. The dependency type and requirement level determine subscription validation behavior.
 */
export async function CreateProductDependency(
  product_id: string,
  data: CreateProductDependencyRequest,
  options?: RequestOptions
): Promise<ProductDependencyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/products/:product_id/dependencies`;
  requestPath = requestPath.replace(':product_id', encodeURIComponent(product_id));
  const requestOptions = options;
  return client.post<ProductDependencyResponse>(requestPath, data, requestOptions);
}
